import {createAction, props} from '@ngrx/store';
import {ApiCisternListResponseDto, ApiCisternRequestDto, ApiCisternResponseDto} from '@birco/rainmesh-api';
import {CisternFilter} from './cistern.state';

const ACTION_PREFIX = '[Cistern]';

export const CisternActions = {
  public: {
    updateCisternFilter: createAction(
      `${ACTION_PREFIX} updateCisternFilter`,
      props<{
        filter: CisternFilter
      }>(),
    ),

    loadAllCisternsByFilters: createAction(
      `${ACTION_PREFIX} loadAllCisternsByFilters`,
      props<{
        filter?: CisternFilter
      } >(),
    ),

    createCistern: createAction(
      `${ACTION_PREFIX} createCistern`,
      props<{
        requestDto: ApiCisternRequestDto
      }>(),
    ),

    updateCistern: createAction(
      `${ACTION_PREFIX} updateCistern`,
      props<{
        id: string,
        requestDto: ApiCisternRequestDto
      }>(),
    ),

    deleteCisternById: createAction(
      `${ACTION_PREFIX} deleteCisternById`,
      props<{
        id: string
      }>(),
    ),

  },
  private: {
    loadCisternsWithFilters: createAction(
      `${ACTION_PREFIX} loadCisternsWithFilters`,
    ),

    loadCisternsSuccess: createAction(
      `${ACTION_PREFIX} loadCisternsSuccess`,
      props<{ cisternsResponseDto: ApiCisternListResponseDto }>(),
    ),

    loadCisternsFailure: createAction(
      `${ACTION_PREFIX} loadCisternsFailure`,
      props<{ error: any }>(),
    ),

    loadCisternsWithProvidedFilters: createAction(
      `${ACTION_PREFIX} loadCisternsWithProvidedFilters`,
      props<{
        filter: CisternFilter
      }>(),
    ),

    loadCisternsWithProvidedFiltersSuccess: createAction(
      `${ACTION_PREFIX} loadCisternsWithProvidedFiltersSuccess`,
      props<{ cisternsResponseDto: ApiCisternListResponseDto }>(),
    ),

    loadCisternsWithProvidedFiltersFailure: createAction(
      `${ACTION_PREFIX} loadCisternsWithProvidedFiltersFailure`,
      props<{ error: any }>(),
    ),

    loadAllCisternsByFiltersSuccess: createAction(
      `${ACTION_PREFIX} loadAllCisternsByFiltersSuccess`,
    ),

    loadAllCisternsByFiltersFailure: createAction(
      `${ACTION_PREFIX} loadAllCisternsByFiltersFailure`,
      props<{ error: any }>(),
    ),

    loadNextOfAll: createAction(
      `${ACTION_PREFIX} loadNextOfAll`,
      props<{
        page: number,
        filter: CisternFilter
      }>(),
    ),

    loadNextOfAllSuccess: createAction(
      `${ACTION_PREFIX} loadNextOfAllSuccess`,
      props<{ cisternsResponseDto: ApiCisternListResponseDto }>(),
    ),

    loadNextOfAllFailure: createAction(
      `${ACTION_PREFIX} loadNextOfAllFailure`,
      props<{ error: any }>(),
    ),

    createCisternSuccess: createAction(
      `${ACTION_PREFIX} createCisternSuccess`,
      props<{ responseDto: ApiCisternResponseDto }>(),
    ),

    createCisternFailure: createAction(
      `${ACTION_PREFIX} createCisternFailure`,
      props<{ error: any }>(),
    ),

    updateCisternSuccess: createAction(
      `${ACTION_PREFIX} updateCisternSuccess`,
      props<{ responseDto: ApiCisternResponseDto }>(),
    ),

    updateCisternFailure: createAction(
      `${ACTION_PREFIX} updateCisternFailure`,
      props<{ id: string, error: any }>(),
    ),

    deleteCisternSuccess: createAction(
      `${ACTION_PREFIX} deleteCisternSuccess`,
      props<{ id: string }>(),
    ),

    deleteCisternFailure: createAction(
      `${ACTION_PREFIX} deleteCisternFailure`,
      props<{ id: string, error: any }>(),
    ),
  }
}
